import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinimize = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-minus",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5 12h14" })
});
export default SvgMinimize;
